export default __webpack_public_path__ + "static/media/linkedin.47f894fa.svg";